import { makeObservable, observable, action, toJS } from "mobx";

class BreadCrumbs {
  data = [];

  constructor() {
    makeObservable(
      this,
      {
        data: observable,
        setBreadcrumbs: action,
      },
      {
        deep: true,
      },
    );
  }

  setBreadcrumbs = (values = []) => {
    this.data = [...values];
  }

  push = (value) => {
    const temp = toJS(this.data);
    temp.push(value);
    this.setBreadcrumbs(temp);
  }
}

const breadCrumbsStore = new BreadCrumbs();
export default breadCrumbsStore;
